import { MediaType } from '@confluence/graphql/entry-points/MediaType';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation';
import { getErrorWithResponse } from '@confluence/graphql/entry-points/getErrorWithResponse';
import { getTraceIdFromResponse, BadStatusError } from '@confluence/network';

export const useExperimentalResetCollabServiceMutation = (options?: {
	variables?: ExperimentalResetCollabServiceMutationVariables;
}): ReturnType<
	typeof useExperimentalMutation<
		ExperimentalResetCollabServiceMutation,
		ExperimentalResetCollabServiceMutationVariables,
		ExperimentalResetCollabServiceMutationResponse
	>
> => {
	return useExperimentalMutation<
		ExperimentalResetCollabServiceMutation,
		ExperimentalResetCollabServiceMutationVariables,
		ExperimentalResetCollabServiceMutationResponse
	>({
		url: (variables) =>
			`/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
		method: 'PUT',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResponseOnSuccess: (response) => ({
			traceId: getTraceIdFromResponse(response) ?? '',
		}),
		parseResult: (json) => ({
			experimentalResetCollabService: {
				traceId: json.traceId,
			},
		}),
		transformError: async (error) => {
			const response = error instanceof BadStatusError ? error.response : undefined;
			if (response) {
				return getErrorWithResponse(error, response);
			}
			return error;
		},
		variables: options?.variables,
	});
};

export interface ExperimentalResetCollabServiceMutation {
	experimentalResetCollabService: ExperimentalResetCollabServiceResponse | null;
}

interface ExperimentalResetCollabServiceResponse {
	traceId: string;
}

export interface ExperimentalResetCollabServiceMutationVariables {
	contentId: string;
	behind: string;
}

interface ExperimentalResetCollabServiceMutationResponse {
	traceId: string;
}
